import React, { Component } from 'react';
import { round } from 'mathjs';
import currencyFormatter from 'currency-formatter';
import moment from 'moment-timezone';

class FundingBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: 'timestamp_ago',
      asc: 1,
      collapse: 'expand',
    };
  }

  rendeCurrency(currency) {
    let color = 'blue';
    if (currency == 'UST') {
      color = 'red';
      currency = 'USDT';
    } else if (currency == 'USD') {
      color = 'black';
    }
    return <span className={'badge bg-' + color}>{currency}</span>;
  }

  renderStatus(data) {
    if (
      data.timestamp * 1000 + data.period * 24 * 60 * 60 * 1000 >=
      Date.now()
    ) {
      return <span className="label label-success">{data.pair}</span>;
    } else {
      return <span className="label label-danger">清算中</span>;
    }
  }

  renderRow(data) {
    // console.log(data);
    var rows = [];
    data
      .sort((a, b) => {
        return a[this.state.sort] > b[this.state.sort]
          ? 1 * this.state.asc
          : -1 * this.state.asc;
      })
      .forEach((item, index) => {
        if (this.state.collapse == 'expand' && index > 9) {
          return true;
        }
        rows.push(
          <tr key={'r' + index}>
            <td style={{ textAlign: 'center' }}>{index + 1}</td>
            <td style={{ textAlign: 'center' }}>
              {this.rendeCurrency(item.currency)}
            </td>
            <td style={{ textAlign: 'right' }}>
              {currencyFormatter.format(item.amount, { code: 'USD' })}
            </td>
            <td style={{ textAlign: 'right' }}>
              {currencyFormatter.format(item.rate, { code: 'USD', symbol: '' })}
              %
            </td>
            <td style={{ textAlign: 'center' }}>
              {item.ago} / {item.period}天
            </td>
            <td style={{ textAlign: 'center' }}>
              {moment
                .utc(item.timestamp * 1000)
                .tz('Asia/Taipei')
                .format('YYYY-MM-DD HH:mm')}
            </td>
            <td style={{ textAlign: 'center' }}>{this.renderStatus(item)}</td>
          </tr>
        );
      });
    return rows;
  }
  render() {
    let data = JSON.parse(this.props.data);
    return (
      <div className="box">
        <div className="box-header">
        </div>
        <div className="box-body padding">
          <h3 className="box-title">FTX 資金費率</h3>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>no.</th>
                  <th>幣種</th>
                  <th>最近一次</th>
                  <th>下一次預估</th>
                  <th>累積年化</th>
                  <th>連續年化</th>
                  <th>正向機率</th>
                  <th>連續</th>
                  <th>合約交易量</th>
                  <th>現貨合約溢價</th>
                </tr>
              </thead>
              <tbody>{this.renderRow(data)}</tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
export default FundingBox;
